import { Autocomplete, Avatar, Box, Button, Card, Chip, Dialog, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputBase, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Stack } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../Loader/Loader';
import Iconify from 'src/components/iconify';
import { formPostData, getData, patchFormData } from 'src/webService/webService';
import uploadIcon from '../../components/images/upload-placeholder.webp';

export default function BrandsForAdmin() {

    const Token = sessionStorage.getItem('Token');
    const [open, setOpen] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [brandList, setBrandList] = useState([]);
    const [activeStates, setActiveStates] = useState({});
    const [approveStates, setApproveStates] = useState({});
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [categoriesArray, setCategoriesArray] = useState([]);
    const [merchant, setMerchant] = useState([]);
    const [preview, setPreview] = useState();
    const [loading, setLoading] = useState(false);
    const [openApproveModal, setOpenApproveModal] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [previewVideo, setPreviewVideo] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [profileCategories, setProfileCategories] = useState([]);
    const [profileIntroVideo, setProfileIntroVideo] = useState('');
    const [imageFiles, setImageFiles] = useState([]);
    const [thumbnail, setThumbnail] = useState(null);
    const [errors, setErrors] = useState({});
    const [action, setAction] = useState('');
    const [selectedBrandId, setSelectedBrandId] = useState(null)

    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const debouncedSearch = debounce((query) => {
        if (query.length >= 3 || query.length === 0) {
            setSearchQuery(query);
            getBrands(1, query);
        }
    }, 500);

    const [formData, setFormData] = useState({
        name: "",
        description: "",
        sizes: '',
        colors: "",
    });
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setThumbnail(file);
        }
    };
    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const videoURL = URL.createObjectURL(file);
            setPreviewVideo(videoURL);
            setProfileIntroVideo(file);
        }
    };
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleCategoryChange = (event, newValue) => {
        const selectedIds = newValue.map((item) => item._id);
        setProfileCategories(selectedIds);
    };

    const handleSubmit = (e) => {
        debugger;
        e.preventDefault();

        const formDataToSend = new FormData();

        formDataToSend.append("name", formData.name);
        formDataToSend.append("description", formData.description);
        formDataToSend.append("category", JSON.stringify(profileCategories));

        // if (profileCategories.length > 0) {
        //     formDataToSend.append("categories", profileCategories.join(','));
        // }

        if (thumbnail) {
            formDataToSend.append("thumbnail", thumbnail);
        }

        if (profileIntroVideo) {
            formDataToSend.append("intro_video", profileIntroVideo);
        }

        imageFiles.forEach((file) => {
            formDataToSend.append("images[]", file);
        });
        formDataToSend.append("_method", "PATCH");

        formPostData(`brands/${selectedBrandId}/update`, formDataToSend, Token)
            .then((res) => {
                getBrands(currentPage);
                toast.success('Brand updated successfully');
                handleClose();
                setImageFiles([]);
                setPreview(uploadIcon);
                setPreviewVideo(null);
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("Error submitting brand");
            });
    };

    const handleSwitchChange = (checked, id) => {
        debugger;
        setActiveStates(prev => ({
            ...prev,
            [id]: !checked,
        }));
        const formData = new FormData();
        formData.append('isActive', checked === false ? 0 : 1)

        patchFormData(`brands/${id}/activate`, formData, Token)
            .then((res) => {
                getBrands(currentPage);
                getCategoryData();
                handleClose();
                handleCloseMenu();
                // toast.success('Brand updated successfully');
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const handleApproveSwitchChange = (checked, id) => {
        debugger;
        setApproveStates(prev => ({
            ...prev,
            [id]: !checked,
        }));
        const formData = new FormData();
        formData.append('isApproved', checked === false ? 0 : 1)

        patchFormData(`brands/${id}/approve`, formData, Token)
            .then((res) => {
                getBrands(currentPage);
                getCategoryData();
                handleClose();
                handleCloseMenu();
                handleApproveClose();
                // toast.success('Brand Approved successfully');
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const handleOpenMenu = (event, id) => {
        setOpen(event.currentTarget);
        getBrandsById(id);
    };
    const handleOpenModal = (id) => {
        debugger
        getCategoryData();
        getBrandsById(id);
        setSelectedBrandId(id);
        setOpenModal(true);
    }
    const handleCloseMenu = () => {
        setOpen(null);
    }

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleClose = () => {
        setOpenModal(false);
        setFormData('');
        setPreview(uploadIcon);
        setOpen(null);
    }

    const getCategoryData = async () => {
        const params = {
            // page: 1,
            // per_page: 20,
            all: 1,
            withChildren: 1
        }
        try {
            const res = await getData('categories', params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setCategoriesArray(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const getBrands = async (page, search = "") => {
        setLoader(true)
        const params = {
            page: page,
            per_page: limit,
            search: search
        }
        try {
            const res = await getData(`brands`, params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setBrandList(res.data)
                setTotalItems(res?.total);
                setTotalPages(res?.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoader(false);
        }
    }

    const getBrandsById = async (id) => {

        try {
            const res = await getData(`brands/${id}`, null, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setPreview(res?.thumbnail);
                setPreviewVideo(res?.intro_video);
                setProfileCategories(res?.category)
                setFormData({
                    name: res?.name,
                    description: res?.description,
                })
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const handleApproveClose = () => {
        setOpenApproveModal(false);
        setSelectedBrand(null)
    }

    const handleApproveOpen = async (item, id) => {
        setSelectedBrand(item)
        setOpenApproveModal(true);
    }

    useEffect(() => {
        getBrands(currentPage);
    }, [limit, currentPage])

    return (
        <div>
            <ToastContainer position='top-right' />
            <Helmet>
                <title>Brands</title>
            </Helmet>
            <div className='p-0 BrandForAdmin'>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <div className='d-flex'>
                        <Typography variant="h4" className='title-color' gutterBottom>
                            Brands
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={2}>
                            <div className='d-flex justify-content-end mb-3'>
                                <Box
                                    sx={{
                                        // display: "flex",
                                        // alignItems: "center",
                                        // justifyContent: "end",
                                        backgroundColor: "none",
                                        borderRadius: "15px",
                                        boxShadow: 1,
                                        // width:'30px',
                                        marginRight: "20px",
                                        border: "1px solid #010101"
                                    }}
                                >
                                    <Iconify icon="eva:search-fill" sx={{ marginLeft: "10px" }} />
                                    <InputBase
                                        placeholder="Search"
                                        value={searchText}
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                            debouncedSearch(e.target.value);
                                        }}
                                        sx={{ marginLeft: "8px" }}
                                    />
                                </Box>

                                {/* <Button variant="contained" className='Button' onClick={(event) =>{ handleOpenModal(); setAction('Add')}} startIcon={<Iconify icon="eva:plus-fill" />}>
                                    Add Brand
                                </Button> */}
                            </div>
                        </Stack>
                    </div>
                </Stack>
                {
                    loader ? (
                        <Loader />
                    ) : (
                        <Card className='card-bg'>
                            <TableContainer style={{ height: "420px", overflowY: "scroll", width: "100%" }}>
                                <Table stickyHeader style={{ width: "100%" }}>
                                    <TableHead>
                                        <TableRow>
                                            {/* <TableCell className="table-cl color-dark" width='20%'>
                                                Brand Thumbnail
                                            </TableCell> */}
                                            <TableCell className="table-cl color-dark mx-10" width='30%'>
                                                Brand Name
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-20">
                                                Brand Category
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-15">
                                                Approval Status
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-15">
                                                Active Status
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-10">
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {brandList?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell className="table-cl color-dark mx-15">
                                                    <Stack
                                                        direction="row"
                                                        alignItems="center"
                                                        spacing={2}
                                                    >
                                                        <div className='d-flex' style={{ alignItems: 'center', gap: '10px' }}>
                                                            {item?.thumbnail ? (
                                                                <Avatar src={item?.thumbnail}></Avatar>
                                                            ) : (
                                                                <Avatar>
                                                                    {item.name
                                                                        ? item.name[0]
                                                                        : null}
                                                                </Avatar>
                                                            )}
                                                            {item?.name}
                                                        </div>
                                                    </Stack>
                                                </TableCell>
                                                <TableCell className="table-cl color-dark mx-10">
                                                    {item?.category_names}
                                                </TableCell>
                                                <TableCell className="table-cl color-dark mx-10">
                                                    <Chip
                                                        label={item?.isApproved === true ? 'Approved' : 'Waiting for Approval'}
                                                        component='a'
                                                        variant='outlined'
                                                        disabled={item?.isApproved === true}
                                                        // onClick={(e) => handleApproveSwitchChange(e.target.checked, item._id)}
                                                        onClick={() => { handleApproveOpen(item, item?._id) }}
                                                        clickable
                                                    />
                                                </TableCell>
                                                <TableCell className="table-cl color-dark mx-10">
                                                    <Switch
                                                        checked={item?.isActive === false ? !activeStates : activeStates}
                                                        onChange={(e) => handleSwitchChange(e.target.checked, item._id)}
                                                    />
                                                </TableCell>
                                                {/* <TableCell className="table-cl color-dark mx-10">
                                                    <IconButton
                                                        size="large"
                                                        color="inherit"
                                                        onClick={(event) => {
                                                            handleOpenMenu(event, item?._id);
                                                            setGetBrandId(item?._id)
                                                        }}
                                                    >
                                                        <Iconify icon={"eva:more-vertical-fill"} />
                                                    </IconButton>
                                                </TableCell> */}
                                                <TableCell className="table-cl color-dark mx-5" width='5%' align="center">
                                                    <IconButton onClick={(event) => { handleOpenModal(item._id); setAction('Edit') }}>
                                                        <Iconify icon="material-symbols:edit" />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="d-flex flex-wrap justify-content-end m-3">
                                <FormControl variant="outlined" size="small" style={{ width: "6%" }}>
                                    <Select
                                        labelId="limit-label"
                                        id="limit-select"
                                        value={limit}
                                        onChange={handleLimitChange}
                                    >
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={20}>20</MenuItem>
                                        <MenuItem value={30}>30</MenuItem>
                                        <MenuItem value={TotalItems}>All</MenuItem>
                                    </Select>
                                </FormControl>
                                <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                    <Iconify icon={"grommet-icons:previous"} />
                                </Button>
                                <Button
                                    onClick={handleNextPage}
                                    disabled={currentPage === totalPages}
                                >
                                    <Iconify icon={"grommet-icons:next"} />
                                </Button>
                            </div>
                        </Card>
                    )
                }
            </div>
            <Dialog open={openModal} maxWidth="md" fullWidth>
                <div className="d-flex justify-content-between">
                    <DialogTitle>{action} Brand</DialogTitle>
                    <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px', cursor: 'pointer' }} onClick={handleClose} />
                </div>
                <DialogContent>
                    <Paper elevation={3} sx={{ padding: 2, marginTop: 0, borderRadius: 2 }}>
                        <form>
                            <Box display="flex" flexDirection="column" gap={2} sx={{ marginTop: 1 }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                id="fileInput"
                                                style={{ display: "none" }}
                                                onChange={handleImageChange}
                                            />
                                            <label htmlFor="fileInput">
                                                <img
                                                    src={preview}
                                                    alt="Uploaded"
                                                    style={{
                                                        width: "300px",
                                                        height: "230px",
                                                        objectFit: "contain",
                                                        cursor: "pointer",
                                                        borderRadius: "10px",
                                                    }}
                                                />
                                                <p className='mb-0' style={{ fontSize: '12px' }}>Upload Thumbnail image</p>
                                            </label>
                                            {errors.thumbnail && (
                                                <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                    {errors.thumbnail}
                                                </p>
                                            )}
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                            <input
                                                type="file"
                                                accept="video/*"
                                                id="videoInput"
                                                style={{ display: "none" }}
                                                onChange={handleVideoChange}
                                            />
                                            <label htmlFor="videoInput">
                                                {previewVideo ? (
                                                    <video
                                                        src={previewVideo}
                                                        controls
                                                        style={{
                                                            width: "300px",
                                                            height: "220px",
                                                            objectFit: "contain",
                                                            cursor: "pointer",
                                                            borderRadius: "10px",
                                                        }}
                                                    />
                                                ) : (
                                                    <div className='VideoForAdmin' style={{
                                                        width: "300px",
                                                        height: "230px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        backgroundColor: "#f0f0f0",
                                                        borderRadius: "10px",
                                                        cursor: "pointer"
                                                    }}>
                                                        <p style={{ fontSize: '14px', color: '#666' }}>Click to upload video</p>
                                                    </div>
                                                )}
                                                <p className='mb-0' style={{ fontSize: '12px' }}>Upload video</p>
                                            </label>
                                        </div>
                                    </Grid>
                                </Grid>
                                <TextField
                                    label="Brand Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                    error={!!errors.name}
                                    helperText={errors.name}
                                />
                                <TextField
                                    label="Description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                    error={!!errors.description}
                                    helperText={errors.description}
                                />
                                <Autocomplete
                                    multiple
                                    required
                                    options={(categoriesArray || []).filter((cat) => cat.subCategoryCount === 0)}
                                    groupBy={(option) => {
                                        const parent = categoriesArray.find(
                                            (parentCat) => parentCat._id == option.parent
                                        );
                                        return parent?.name || 'Uncategoriezed';
                                    }}
                                    getOptionLabel={(option) => ((option.parent != null) ? "" : "") + `${option.name}`}
                                    value={categoriesArray.filter((item) => profileCategories.includes(item._id))}
                                    onChange={handleCategoryChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Category" variant="outlined" />
                                    )}
                                    renderGroup={(params) => (
                                        <div key={params.key}>
                                            <Typography sx={{ mt: 0, mb: 0, fontWeight: 'bold', px: 2, background: '#dbdee2' }}>
                                                {params.group}
                                            </Typography>
                                            {params.children}
                                        </div>
                                    )}
                                />
                                <div className='mt-4 d-flex justify-content-end'>
                                    <Button variant="contained" type="submit" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </div>
                            </Box>
                        </form>
                    </Paper>
                </DialogContent>
            </Dialog>
            <Dialog open={openApproveModal} onClose={handleApproveClose} maxWidth="sm" fullWidth>
                <Iconify icon='material-symbols:close-rounded' sx={{ margin: '10px 0px 0px 95%', cursor: "pointer", display: 'flex', justifyContent: 'end' }} onClick={handleApproveClose} />
                <DialogContent className="p-5">
                    {selectedBrand && (
                        <div className="d-flex gap-4">
                            {/* Thumbnail / Avatar Section */}
                            <div className="flex-shrink-0">
                                {selectedBrand.thumbnail ? (
                                    <img
                                        src={selectedBrand.thumbnail}
                                        alt="Thumbnail"
                                        style={{
                                            width: "200px",
                                            height: "180px",
                                            objectFit: "contain",
                                            cursor: "pointer",
                                            borderRadius: "10px",
                                        }}
                                    />
                                ) : (
                                    <Avatar sx={{ width: 100, height: 100 }}>
                                        {selectedBrand.name ? selectedBrand.name[0] : ''}
                                    </Avatar>
                                )}
                            </div>

                            {/* Text and Button Section */}
                            <div className="d-flex flex-column justify-content-between w-100">
                                <div>
                                    <Typography variant="h5" className="mb-3">{selectedBrand.name}</Typography>

                                    <div className="mb-2">
                                        <Typography variant="subtitle1" fontWeight="bold">Description:</Typography>
                                        <Typography variant="body1">
                                            {selectedBrand.description || 'No description available'}
                                        </Typography>
                                    </div>

                                    <div className="mb-2">
                                        <Typography variant="subtitle1" fontWeight="bold">Categories:</Typography>
                                        <Typography variant="body1">
                                            {selectedBrand.category_names || 'No categories assigned'}
                                        </Typography>
                                    </div>
                                </div>

                                {/* Approve Button */}
                                <div className="d-flex justify-content-end mt-3">
                                    <Button
                                        variant="contained"
                                        className="w-50"
                                        onClick={() => handleApproveSwitchChange(true, selectedBrand._id)}
                                    >
                                        Approve
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </DialogContent>
            </Dialog>

        </div >
    )
};